// noinspection JSUnusedGlobalSymbols

export class ResetPwInfo {
  constructor(
    public currentPassword: string,
    public newPassword: string
  ) {
  }
}
